import { useLocation, Navigate, Outlet } from "react-router-dom";
import { persistor, useAppDispatch } from "../redux/store";
import { useEffect, useRef, useState } from "react";
import { getCurrentUser, signOut } from "aws-amplify/auth";
import { logout } from "../redux/slice/persist/authSlice";
import apiConfig from "../app/api/apiConfig";

const AUTH_STALE_TIME = 30 * 60 * 1000;

export function AuthGuard() {
  const [isBusy, setBusy] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  let location = useLocation();
  const lastAuthCheckTime = useRef<number | null>(null);
  const dispatch = useAppDispatch();

  useEffect(() => {
    // no document.title
    const fetchCognitoGetCurrentUser = async () => {
      const now = Date.now();
      if (
        lastAuthCheckTime.current &&
        now - lastAuthCheckTime.current < AUTH_STALE_TIME
      ) {
        setBusy(false);
        return;
      }

      try {
        await getCurrentUser();
        setIsLoggedIn(true);
        lastAuthCheckTime.current = now;
      } catch (e) {
        setIsLoggedIn(false);
        await signOut();
        persistor.purge();
        dispatch(logout());
        dispatch(apiConfig.util.resetApiState());
        console.log(e);
      } finally {
        setBusy(false);
      }
    };
    fetchCognitoGetCurrentUser();
    // eslint-disable-next-line
  }, [location]);

  if (isBusy) {
    return null;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
